import { TComputedPropMapper } from '../../../types/computed-props-mapper';

export const isFromBank: TComputedPropMapper<boolean> = ({ offer: { user } }) => Boolean(user && !!user.bank);
